'use strict';
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export function FormGroupInnerInlineLabel(props) {
  const { size, label, children, required } = props;
  return (
    <div
      className={classnames("col-sm-" + size, "col-xs-12 form-group inline-form-group")}>
      <label
        required={required}
        className="control-label"
      >
        {label}
      </label>
      <div className="block">
        {children}
      </div>
    </div>
  );
}

FormGroupInnerInlineLabel.propTypes = {
  size: PropTypes.number,
  label: PropTypes.string,
};
FormGroupInnerInlineLabel.defaultProps = {
  size: 6
};

export default FormGroupInnerInlineLabel;
